<template>
  <div class="homepage_wrap">
    <routerCom btnIndex="2" :changePop="changePop"/>
    <div class="imgArr">
      <img style="margin-top: -6px;" src="../assets/img/Company/titleBg.png" alt="" />
      <div class="app">
        <div class="app-item" :onClick="openE100">
          <img style="width: 500px;" src="../assets/img/Company/info1.png" />
          <div class="text">
            <div class="text-title">中智鼎证E100-汽车电子数据读取系统</div>
            <div class="text-info">中智鼎证E100是一款提取汽车EDR数据的新技术装备，支持PC和移动端，服务于交通事故责任识别、司法鉴定、保险理赔、二手车评估、年检检测等领域。 中智鼎证E100是一款提取汽车EDR数据的新技术装备，支持PC和移动端，</div>
          </div>
        </div>

        <div class="app-item">
          <div class="text">
            <div class="text-title">中智鼎证V100-汽车行驶记录仪数据解析软件</div>
            <div class="text-info">中智鼎证V100是一款解析汽车行驶记录仪数据的专业软件，服务于交通事故责任识别、司法鉴定、超速及疲劳驾驶检测等。
              软件具备强大的数据解析能力，能够准确解读汽车行驶记录仪中的各种数据，全面了解车辆在特定时间段内的运行状况。</div>
          </div>
          <img style="width: 500px;" src="../assets/img/Company/info2.png" />
        </div>

        <div class="app-item">
          <img style="width: 500px;" src="../assets/img/Company/info3.png" />
          <div class="text">
            <div class="text-title">中智鼎证APP-汽车电子取证综合工具和社区</div>
            <div class="text-info">中智鼎证APP是一个涵盖汽车电子取证各领域和环节的综合工具及社区，提供包括但不限于EDR检测、VDR检测在内的多项功能及社区服务，帮助用户在汽车电子取证的各个领域和场景有效提升效率和体验。</div>
          </div>
        </div>
      </div>
      <img src="../assets/img/home/infoBg.png" alt="" />
    </div>
  </div>
</template>

<script>
import routerCom from './routerCom.vue'
export default {
  name: 'Company',
  components:{
    routerCom,
  },
  props: {
    isPopShow:Function
  },
  methods: {
		openE100() {
			this.$router.push("/appInfoE100");
		},
    changePop(isp){
      this.isPopShow(isp);
    }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.homepage_wrap {
	width: 1280px;
	margin: auto;
  text-align: center;
}

.app{
  margin: auto;
  text-align: center;
}

.app .app-item{
  width: 1200px;
  height: 300px;
  margin: auto;
  display: flex;
}

.app .app-item .text{
  width: 560px;
}

.app .app-item img{
  margin:auto;
}

.imgArr img{
  margin: 32px auto 0 auto;
  max-width: 1280px;
}

.text{
  text-align: center;
  height: 100%;
}

.text .text-title{
  font-family: Noto Sans SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  color: #131313;

  margin: 80px 40px 0 40px;
}

.text .text-info{
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: #9E9E9E;

  margin: 20px 40px 0 40px;
}
</style>
